"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeletePartnerAction = void 0;
const common_1 = require("../../common");
class DeletePartnerAction extends common_1.UpdateAction {
}
exports.DeletePartnerAction = DeletePartnerAction;
//# sourceMappingURL=delete-partner.action.js.map